module.exports = __webpack_public_path__ + "img/support-sass.0ddf137a.png";